import { RIGHT, LEFT } from '../directions.js';
import { FRONT, BACK, INNER_LEFT, INNER_RIGHT } from '../side-ids';

export default {
  id: 'klappkarte-hoch-105x148',
  sides: [
    {
      id: FRONT,
      // how much to shift the side (in mm),
      // needed so that card sides fit onto each other when printed
      shifts: {
        [RIGHT]: 1.5,
      },
    },
    {
      id: INNER_LEFT,
      shifts: {
        [LEFT]: 1.5,
      },
    },
    {
      id: INNER_RIGHT,
      shifts: {
        [RIGHT]: 1.5,
      },
    },
    {
      id: BACK,
      shifts: {
        [LEFT]: 1.5,
      },
    },
  ],
};
